<div class="mail-history-for-transfer">
  <div class="mail-history-selection-panel" *ngIf="selectionEnabled !== 'DISABLED'">
    <div class="selected-mail-counter">
      <h4 class="including-mails">{{ 'commons:history.mail.including_mail' | translate }}</h4>
      <h4 class="including-mails-number">({{ selectedMailCounter }}/{{ internalEvents.length }})</h4>
    </div>
    <p class="selection-all-actions">
      <button mat-button type="button" [disabled]="selectedMailCounter === internalEvents.length" (click)="selectAllMails()">
        {{ 'commons:history.mail.select_all' | translate }}
      </button>
      <button mat-button type="button" [disabled]="selectedMailCounter === 0" (click)="unSelectAllMails()">
        {{ 'commons:history.mail.unselect_all' | translate }}
      </button>
    </p>
  </div>
  <div class="mail-history-details" [class.no-selection]="selectionEnabled === 'DISABLED'">
    <mat-accordion multi displayMode="flat">
      <mat-expansion-panel
        *ngFor="let event of internalEvents; let idx = index; let last = last"
        hideToggle
        [expanded]="event.open"
        [disabled]="event.disabled"
        [class.disabled]="event.disabled"
        (closed)="event.open = false"
        (opened)="event.open = true"
      >
        <mat-expansion-panel-header [class.selected]="event.selected">
          <div class="flex-row event-header">
            <div class="flex-row event-header-info">
              <div
                class="event-header-icon"
                [ngClass]="{ 'cng-ico_menu_open': !event.disabled && event.open, 'cng-ico_menu_close': !event.disabled && !event.open }"
                [attr.aria-hidden]="true"
              ></div>
              <div class="event-header-date ellipsis" title="{{ getHeaderDate(event.evt) }}">{{ getHeaderDate(event.evt) }}</div>
              <div class="event-header-title cng-tooltip-comment" [class.ellipsis]="!last">
                <div *ngIf="event.conversational" title="{{ event.evt.subject }}">
                  <span
                    class="event-header-title-text"
                    [ngClass]="{ 'cng-ico_up': isIncommingMessage(event.evt), 'cng-ico_down': !isIncommingMessage(event.evt) }"
                  >
                    {{ event.evt.subject }}
                  </span>
                </div>
                <div *ngIf="!event.conversational">{{ event.evt.description.title }}</div>
                <span class="event-header-ticket cng-ico_ticket"></span><span>{{ event.evt.requestId }}</span>
                <cng-tooltip-comment
                  *ngIf="idx === 0 && memo.message"
                  [date]="memo.date"
                  class="event-header-comment"
                  [content]="memo.message"
                  placement="bottom-right"
                >
                </cng-tooltip-comment>
              </div>
            </div>
            <div class="attachment" (click)="clickOnAttachment($event, event)">
              <cng-attachment class="attachment-light" [attachments]="event.allAttachment"></cng-attachment>
            </div>
            <section
              class="mail-history-selection"
              (click)="$event.stopPropagation()"
              *ngIf="selectionEnabled !== 'DISABLED'"
              [hidden]="selectionEnabled === 'NONE_OR_ALL'"
            >
              <mat-checkbox
                type="checkbox"
                class="mail-history-checkbox"
                [checked]="event.selected"
                [aria-label]="'checkValue' + event.evt.contentId"
                [disabled]="event.disabled"
                (change)="toggleMailHistorySelection(event)"
              >
              </mat-checkbox>
            </section>
          </div>
        </mat-expansion-panel-header>
        <div *ngIf="event.conversational && event.open" class="flex-column event-container">
          <div *ngIf="event.evt.sender || event.evt.recipient" class="flex-column event-information">
            <div *ngIf="!isEmpty(event.evt.sender)" class="flex-row">
              <div class="label">{{ 'commons:history.mail.from' | translate }}</div>
              <div class="description" [innerHTML]="event.evt.sender"></div>
            </div>
            <div *ngIf="!isEmpty(event.evt.recipient)" class="flex-row">
              <div class="label">{{ 'commons:history.mail.to' | translate }}</div>
              <div class="description" [innerHTML]="event.evt.recipient"></div>
            </div>
            <div *ngIf="!isEmpty(event.evt.ccRecipient)" class="flex-row">
              <div class="label">{{ 'commons:history.mail.cc' | translate }}</div>
              <div class="description" [innerHTML]="event.evt.ccRecipient"></div>
            </div>
          </div>
          <div class="switchHtml">
            <label [for]="'switch' + idx">
              {{ 'commons:history.mail.switch.html' | translate }}
              <cng-switch switchId="switch{{ idx }}" [switchValue]="event.isHtmlFormat" (switchChange)="clickOnSwitch(event)"> </cng-switch>
              {{ 'commons:history.mail.switch.text' | translate }}
            </label>
          </div>
          <div id="switchTxt{{ idx }}" *ngIf="!isEmpty(event.evt.content) && !event.isHtmlFormat" class="flex-column event-message">
            <div class="description txt-wrapper">{{ event.evt.content }}</div>
          </div>
          <div id="switchHtml{{ idx }}" *ngIf="!isEmpty(event.evt.contentHtml) && event.isHtmlFormat" class="flex-column event-message">
            <div class="description" [innerHTML]="event.safeContentHtml"></div>
          </div>
        </div>
        <div *ngIf="!event.conversational && event.open" class="event-container small">
          <mail-comment [epticaEvent]="event.evt" [showAttachment]="false"></mail-comment>
        </div>
      </mat-expansion-panel>
    </mat-accordion>
  </div>
</div>
